export default __webpack_public_path__ + "static/media/as.04c7dbe9.svg";